import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table, DatePicker, Icon } from 'antd';

import { columnesTaulaHistoricObservadors } from './configuracioTaulaHistoricObservadors';
import { convertirTextAMomentUTC, MASCARA_DDMMYYYY, MASCARA_YYYYMMDD, esDataIniciPeriodeDeshabilitat, esDataFiPeriodeDeshabilitat } from '../../commons/gestioDates';
import { estacioIntroduccioEliminarObservadorHistoric, estacioIntroduccioModificarObservadorHistoric } from '../../actions/estacio';
import { selectorHistoricObservadorsEditadesAmbNomCognomsICodi } from '../../selectors/selector_estacio_formulari_dades';

const granuralitat = 'days';

const utcDateRender = (current) => {
    return (
        <div className="ant-calendar-date" >
            {current.utc().date()}
        </div>
    );
};

class EstacioIntroduccioHistoricObservadors extends Component {

    constructor(props) {
        super(props);

        this.renderIconeEliminarObservador = this.renderIconeEliminarObservador.bind(this);
        this.deshabilitarDataAlta = this.deshabilitarDataAlta.bind(this);
        /*
        Afegim un atribut id als observadors per tal de poder identificarlos i poder realitzar operacions sobre ells.
        El identificador que es possa es el index del array. Aquest identificador es possara cada cop que el
        componenent rebi noves props.
        */
        this.historicObservadors = this.props.historicObservadors.map((element, index) => {
            return {
                ...element,
                id: index
            };
        });

        this.columnes = this.crearColumnesPerTaula(columnesTaulaHistoricObservadors());
    }

    componentWillReceiveProps(nextProps) {
        //Afegim els index als elements per poder utilitzarlos com id
        this.historicObservadors = this.afegirIdAlsHistoricObservadors(nextProps.historicObservadors);
    }

    crearColumnesPerTaula(columnes) {
        columnes.forEach((columna) => {
            if (columna.key === 'dataAlta') {
                columna.render = (text, record) => this.renderColumnaDataAlta(text, record);
            }

            if (columna.key === 'dataBaixa') {
                columna.render = (text, record) => this.renderColumnaDataBaixa(text, record);
            }
        });

        columnes.push({
            title: '',
            className: 'estacio-introduccio-taula-columna-eliminar',
            render: this.renderIconeEliminarObservador
        });

        return columnes;
    }

    afegirIdAlsHistoricObservadors(historicObservadors) {
        return historicObservadors.map((element, index) => {
            return {
                ...element,
                id: index
            };
        });
    }

    deshabilitarDataAlta(dataCalendari, dataBaixa) {
        const dataActual = convertirTextAMomentUTC(this.props.dataActualText);
        return esDataIniciPeriodeDeshabilitat(dataCalendari, dataActual, dataBaixa, granuralitat);
    }

    deshabilitarDataBaixa(dataCalendari, dataAlta) {
        const dataActual = convertirTextAMomentUTC(this.props.dataActualText);
        return esDataFiPeriodeDeshabilitat(dataCalendari, dataActual, dataAlta, granuralitat);
    }

    /**
     *
     * @param {*} dataAsText
     * @param {*} observadorHistoric
     */
    renderColumnaDataAlta(dataAsText, observadorHistoric) {
        const dataIndexColumna = 'dataAlta';
        const dataAsMoment = (dataAsText) ? convertirTextAMomentUTC(dataAsText, MASCARA_YYYYMMDD) : null;

        const optionsPerDataAlta = {
            allowClear: false,
            disabledDate: (data) => this.deshabilitarDataAlta(data, observadorHistoric.dataBaixa)
        };

        return this.renderDatePicker(optionsPerDataAlta, observadorHistoric.id, dataIndexColumna, dataAsMoment);
    }

    /**
     *
     * @param {*} dataAsText
     * @param {*} observadorHistoric
     */
    renderColumnaDataBaixa(dataAsText, observadorHistoric) {
        const dataIndexColumna = 'dataBaixa';

        const dataAsMoment = (dataAsText) ? convertirTextAMomentUTC(dataAsText, MASCARA_YYYYMMDD) : null;
        const allowClear = (this.props.dataBaixaEstacioText) ? false : true;

        const optionsPerDataBaixa = {
            allowClear,
            disabledDate: (data) => this.deshabilitarDataBaixa(data, observadorHistoric.dataAlta)
        };

        return this.renderDatePicker(optionsPerDataBaixa, observadorHistoric.id, dataIndexColumna, dataAsMoment);
    }

    renderDatePicker(options, idHistoricObservador, dataIndexColumna, data) {
        return <DatePicker
            placeholder='Seleccionar'
            dateRender={utcDateRender}
            value={data}
            format={MASCARA_DDMMYYYY}
            onChange={this.onEditarDataDeUnObservador.bind(this, idHistoricObservador, dataIndexColumna)}
            {...options}
        />;
    }

    /**
     * Accio que es llença quan es modifica el datepicker dintre de la taula.
     * @param {*} idObservador
     * @param {*} atribut
     * @param {*} dataAsMoment
     */
    onEditarDataDeUnObservador(idObservador, atribut, dataAsMoment) {
        //La data de alta es obligatoria, per tant no deixem possar nulls.
        const { dataBaixaEstacioText, estacioIntroduccioModificarObservadorHistoric } = this.props;

        if (atribut === 'dataBaixa' && dataBaixaEstacioText && !dataAsMoment) {
            return;
        }

        if (atribut === 'dataAlta' && !dataAsMoment) {
            return;
        }

        let data = {
            [atribut]: (dataAsMoment) ? dataAsMoment.startOf('day') : dataAsMoment
        };

        estacioIntroduccioModificarObservadorHistoric(idObservador, data);
    }

    /**
     * Renderitza una icona que permet eliminar un observador.
     * @param {*} text
     * @param {*} record
     */
    renderIconeEliminarObservador(text, record) {
        return (
            <span>
                <Icon type="delete"
                    className="icona-eliminar-sense-margin icona-eliminar"
                    onClick={() => this.props.estacioIntroduccioEliminarObservadorHistoric(record.id)} />
            </span>
        );
    }

    render() {
        return (
            <Table
                rowKey={(record, index) => index}
                dataSource={this.historicObservadors}
                columns={this.columnes}
                size='small'
                bordered
                pagination={{ pageSize: 4, hideOnSinglePage: true }}
            />
        );
    }
}

EstacioIntroduccioHistoricObservadors.propTypes = {
    dataActualText: PropTypes.string.isRequired,
    historicObservadors: PropTypes.arrayOf(
        PropTypes.shape({
            idEstacioUsuari: PropTypes.number,
            idUsuari: PropTypes.number.isRequired,
            nomComplet: PropTypes.string,
            codi: PropTypes.string,
            dataAlta: PropTypes.string.isRequired,
            dataBaixa: PropTypes.string
        })
    ),
    estacioIntroduccioEliminarObservadorHistoric: PropTypes.func.isRequired,
    estacioIntroduccioModificarObservadorHistoric: PropTypes.func.isRequired,
    dataBaixaEstacioText: PropTypes.string
};

const mapDispatchToProps = {
    estacioIntroduccioEliminarObservadorHistoric,
    estacioIntroduccioModificarObservadorHistoric
};

const mapStateToProps = (state) => {
    return {
        historicObservadors: selectorHistoricObservadorsEditadesAmbNomCognomsICodi(state),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EstacioIntroduccioHistoricObservadors);



// WEBPACK FOOTER //
// ./src/components/estacio/estacioIntroduccioHistoricObservadorsTaula.js